"use strict";

document.addEventListener('DOMContentLoaded', () => {
	const CALC_TYPE = 'osago'

	// const polisStartDateByDefault = today.getFullYear()+'-'+(today.getMonth()+1).toString().padStart(2, "0")+'-'+((today.getDate()+1).toString().padStart(2, "0"))
	const polisStartDateByDefault = moment().add(1, 'days').format('YYYY-MM-DD')

	const API = 'https://api.greentravel.ua/api'

	const CALC_URL = (window.location.href.includes('calcs_test'))
		? 'https://greentravel.ua/calcs_test'
		: 'https://greentravel.ua/calcs_vue'


	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}


	const { createApp } = Vue
	const APP = createApp({
		data() {
			return {
				fields: {
					trip_duration: 12,
					// city_name: '',
					// city_id: null, // Киев = 244
					franchise: "0",
					dgo_limit: 0,
					use_as_taxi: false,
					use_scoring: -1,
					insurance_company: '',
					scoringBirthYear: 2002,
					discount_check: false,
					discount_type: 0,
					polis_start: polisStartDateByDefault,
					comment: "",
					promocode: "",
					transport: {
						transport_category_id: 1,
						transport_power_id: 1,
						car_mark: {
							name: '',
							code: null,
							id: null,
						},
						car_model: {
							name: '',
							code: null,
							id: null,
						},
						// car_mark_id: 		null,
						// car_mark_code: 	null,
						// car_model_id: 	null,
						// car_model_code: null,
						// car_mark: '',
						// car_model: '',
						car_year: 2010,
						gov_num: '',
						vin: '',
						city: {
							id: null,
							name: '',
						}
					},
					insurant: {
						type: "physical",
						phone: "",
						surname: "",
						name: "",
						patronymic: "",
						inn: "",
						birth: "2000-01-01",
						email: "",
						city: "",
						street: "",
						house: "",
						flat: "",
						address: "",
						doc_type: 1,
						doc_number: "",
						doc_series: "",
						doc_adv: "",
						doc_given: "",
						doc_date: "2020-01-01"
					},
					cashback: {
						selected: 'phone',
						is_phone_changed: false,
						phone: "",
						zsu: "",
						bankcard: "",
					}
				},


				status: {
					steps: {
						current: 0,
					},
					validation: {
						elements: {},
					},
					isTest: false,
					isCarFoundByGovNum: -1, // -1: юзер введёт вручную; 0: не нашло; 1: нашло на 1м шаге; 2: нашло на другом шаге
					messages: {},

					price: {
						by_companies: null,
						total: null,
						cashback: null
					},

					selectedInsurance: {
						insurance_company: '',
						amount:null,
						cashback:null,
						total:null
					},

					user_data: {
						insurant: {
							doc_series: '',
						}
					}
				},


				handbooks: Object.assign({},
					window.calc_handbooks,
					{
						doc_types: {
							1: 'Паспорт',
							2: 'ID-паспорт',
							3: 'Водійське посвідчення'
						}
					}
				),

				draft: false,
				uuid: '',
			}
		},


		methods: {
			async gotoStep(step_n) {
				DD.log('gotoStep: ', step_n)

				// если шаг впепрёд - проверяем текущий. Если шаг назад - пускаем сразу
				if (step_n > this.status.steps.current) {
					try {
						const fieldValidationResult = await this.validateStep()
						if (fieldValidationResult) this.status.steps.current = step_n
					} catch (error) {
						DD.error('ERR: ошибка validateStep-валидации в gotoStep');
					}
				} else {
					this.status.steps.current = step_n
				}

				const elementPosition = document.querySelector('#calc').getBoundingClientRect().top + window.scrollY
				window.scrollTo({
					top: elementPosition - 200,
					behavior: 'smooth'
				})
			},



			async validateStep() {
				let isValidStep = true;

				// Проходим по всем полям валидации
				for (let [field, validation] of Object.entries(this.status.validation.elements)) {
					if (validation.isVisible()) {
						try {
							const fieldValidationResult = await validation.validate()
							if (isValidStep && fieldValidationResult === false) {
								isValidStep = false;
							}

						} catch (error) {
							isValidStep = false;
						}
					}
				}

				// Логирование итогового результата валидации шага
				isValidStep ? DD.log('✅ VALID STEP') : DD.error('❌ INVALID STEP');
				return isValidStep;
			},




			choose_insurance(name) {
				this.fields.insurance_company = name
				const insurance = this.status.price.by_companies.find(item => item.insurance_company === name)
				// console.log('choose_insurance', this.fields.insurance_company, insurance)
				this.status.selectedInsurance = insurance
			},



			getPrice() {
				function isPropsFilled(obj) {
					// return _.every(_.values(obj), value => !_.isEmpty(value))
					// return Object.values(obj).every(value => value !== undefined && value !== null)
					// DD.log('CHECKING getPrice() isPropsFilled', obj) : null
					for (let key in obj) {
						if (typeof obj[key] == 'undefined' || obj[key] == null) {
							console.warn('getPrice() empty key: ', key)
							return false;
						}
					}
					return true;
				}

				this.status.price.total = null
				this.status.cashback = 0

				const priceRequest = {
					"city_id": this.fields.transport.city.id != '' ? parseInt(this.fields.transport.city.id) : null,
					"trip_duration": this.fields.trip_duration != '' ? parseInt(this.fields.trip_duration) : null,
					"franchise": this.fields.franchise != '' ? parseInt(this.fields.franchise) : null,
					"dgo_limit": this.fields.dgo_limit != '' ? parseInt(this.fields.dgo_limit) : 0,
					"use_as_taxi": Boolean(this.fields.use_as_taxi),
					"discount_check": Boolean(this.fields.discount_check),
					// "promocode": 			this.fields.promocode,
					"transport": {
						"transport_power_id": parseInt(this.fields.transport.transport_power_id),
						"car_year": parseInt(this.fields.transport.car_year)
					},
					"insurant": {
						"type": this.fields.insurant.type,
					},
					// "cashback_phone": 	this.fields.cashback.phone,
					"cashback_phone": this.fields.cashback.phone,
					"cashback_to_vsu": this.fields.cashback.zsu,
					"cashback_card": this.fields.cashback.bankcard,
				}


				// проверка обязательных полей для запроса цены. Именно тут т.к. выше обязательные поля
				if (isPropsFilled(priceRequest) == false) {
					DD.error('getPrice(): не все поля в priceRequest заполнены', priceRequest)
					return false
				}


				if (priceRequest.discount_check)
					priceRequest.discount_type = this.fields.discount_type

				// scoring
				if (this.fields.use_scoring && this.fields.transport.car_year > 0 && this.fields.scoringBirthYear > 0) {
					_.merge(priceRequest, {
						use_scoring: Boolean(this.fields.use_scoring),
						transport: {
							car_year: parseInt(this.fields.transport.car_year),
						},
						insurant: {
							birth: this.fields.scoringBirthYear + "-06-01"
						}
					})
				}


				axios.post(API + '/v2/osago/calculate', priceRequest, {
					timeout: 10000,
					headers: {
						'Access-Control-Allow-Origin': 'https://' + window.location.host,
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
					.then((response) => {
						DD.log('GET PRICE:', response.data)
						this.status.price.by_companies = response.data
					})
					.catch((error) => {
						this.log({
							method: 'getPrice',
							error: error,
							data: this.fields
						}, CALC_TYPE + '-error')

						this.status.price.by_companies = []

						Swal.fire({
							icon: 'error',
							title: 'Помилка',
							text: DEFAULT_ERR_TEXT,
						})

					})
			},


			saveDraft() {
				const ga_id = getCookie('_ga')

				const cashback = this.getCashback()

				let draftRequest = {
					"ga_id": ga_id,
					"city_id": parseInt(this.fields.transport.city.id),
					"trip_duration": parseInt(this.fields.trip_duration),
					"franchise": parseInt(this.fields.franchise),
					"dgo_limit": parseInt(this.fields.dgo_limit),

					"cashback_phone": cashback.phone,
					"cashback_to_vsu": cashback.zsu,
					"cashback_card": cashback.bankcard,

					"use_as_taxi": this.fields.use_as_taxi,
					"discount_check": this.fields.discount_check,
					"discount_type":
						this.fields.discount_check == 0
							? null : this.fields.discount_type,
					"email": this.fields.insurant.email,
					"polis_start": this.fields.polis_start,
					"upload_docs": false,
					"comment": this.fields.comment,
					"promocode": this.fields.promocode,
					"dont_call": true,
					"insurance_company": this.fields.insurance_company,
					"transport": {
						"transport_category_id": parseInt(this.fields.transport.transport_category_id),
						"transport_power_id": parseInt(this.fields.transport.transport_power_id),
						"car_mark_code": this.fields.transport.car_mark.code,
						"car_model_code": this.fields.transport.car_model.code,
						"gov_num": this.fields.transport.gov_num,
						"vin": this.fields.transport.vin,
						"car_year": parseInt(this.fields.transport.car_year)
					},
					"insurant": {
						"type": this.fields.insurant.type,
						"phone": this.fields.insurant.phone,
						"surname": this.fields.insurant.surname,
						"name": this.fields.insurant.name,
						"patronymic": this.fields.insurant.patronymic,
						"inn": this.fields.insurant.inn,
						"birth": this.fields.insurant.birth,
						"address": this.fields.insurant.address,
						"doc_type": parseInt(this.fields.insurant.doc_type),
						"doc_number": this.fields.insurant.doc_number.toString(),
						"doc_series": this.fields.insurant.doc_series.toString(),
						"doc_adv": this.fields.insurant.doc_adv.toString(),
						"doc_given": this.fields.insurant.doc_given,
						"doc_date": this.fields.insurant.doc_date
					}
				}
				if (this.uuid != '') draftRequest.uuid = this.uuid


				DD.log('saveDraft', draftRequest)
				// DD.log('priceRequest', priceRequest):''

				// axios.post(API + '/osago/ingo/draft', draftRequest, {
				axios.post(API + '/v2/osago/draft', draftRequest, {
					headers: {
						'Access-Control-Allow-Origin': 'https://greentravel.ua',
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})

					.then((response) => {
						DD.log('saveDraft request:', response.data)
						if (this.uuid == '') this.uuid = response.data.uuid
					})

					.catch((error) => {
						this.draft = false

						this.log({
							method: 'saveDraft -- self',
							error: error,
							data: this.calcFields
						}, 'osago-error')

						if (error.response) {
							this.log({
								method: 'saveDraft',
								error: error,
								data: this.fields
							}, CALC_TYPE + '-error')

							if (error.response) {
								console.log(error.response)

							} else if (error.request) {
								console.log(error.request);
							}
						}
					})
			},



			checkoutDraft() {
				this.draft = 'request'
				const ga_id = getCookie('_ga')
				const checkoutBtn = document.querySelector('#calc .calcStep._active .btn_checkout')
				checkoutBtn.classList.add('_loading')

				const cashback = this.getCashback()

				let draftRequest = {
					"ga_id": ga_id,
					"city_id": parseInt(this.fields.transport.city.id),
					"trip_duration": parseInt(this.fields.trip_duration),
					"franchise": parseInt(this.fields.franchise),
					"dgo_limit": parseInt(this.fields.dgo_limit),

					"cashback_phone": cashback.phone,
					"cashback_to_vsu": cashback.zsu,
					"cashback_card": cashback.bankcard,

					"use_as_taxi": this.fields.use_as_taxi,
					"discount_check": this.fields.discount_check,
					"discount_type":
						this.fields.discount_check == 0
							? null : parseInt(this.fields.discount_type),
					"email": this.fields.insurant.email,
					"polis_start": this.fields.polis_start,
					"upload_docs": false,
					"comment": this.fields.comment,
					"promocode": this.fields.promocode,
					"dont_call": true,
					"insurance_company": this.fields.insurance_company,
					"transport": {
						"transport_category_id": parseInt(this.fields.transport.transport_category_id),
						"transport_power_id": parseInt(this.fields.transport.transport_power_id),
						"car_mark_code": this.fields.transport.car_mark.code,
						"car_model_code": this.fields.transport.car_model.code,
						"gov_num": this.fields.transport.gov_num,
						"vin": this.fields.transport.vin,
						"car_year": parseInt(this.fields.transport.car_year)
					},
					"insurant": {
						"type": this.fields.insurant.type,
						"phone": this.fields.insurant.phone,
						"surname": this.fields.insurant.surname,
						"name": this.fields.insurant.name,
						"patronymic": this.fields.insurant.patronymic,
						"inn": this.fields.insurant.inn,
						"birth": this.fields.insurant.birth,
						"address": this.fields.insurant.address,
						"doc_type": parseInt(this.fields.insurant.doc_type),
						"doc_number": this.fields.insurant.doc_number.toString(),
						"doc_series": this.fields.insurant.doc_series.toString(),
						"doc_adv": this.fields.insurant.doc_adv.toString(),
						"doc_given": this.fields.insurant.doc_given,
						"doc_date": this.fields.insurant.doc_date
					}
				}

				// scoring
				if (this.fields.use_scoring && this.fields.transport.car_year > 0 && this.fields.scoringBirthYear > 0) {
					let insBirthday = this.fields.insurant.birth != null
						? this.fields.insurant.birth
						: this.fields.scoringBirthYear + "-06-01"

					_.merge(draftRequest, {
						use_scoring: Boolean(this.fields.use_scoring),
						transport: {
							car_year: this.fields.transport.car_year,
						},
						insurant: {
							birth: insBirthday
						}
					})
				}

				// льгота
				if (this.fields.discount_check) {
					DD.log('===DISCOUNT')
					_.merge(draftRequest, {
						insurant: {
							discount_doc_number: this.fields.insurant.discount_doc_number,
							discount_doc_series: this.fields.insurant.discount_doc_series,
							discount_doc_given: this.fields.insurant.discount_doc_given,
							discount_doc_date: this.fields.insurant.discount_doc_date,
						}
					})
				}

				DD.log('draftRequest', draftRequest)

				// axios.post(API + '/osago/ingo', draftRequest, {
				axios.post(API + '/v2/osago', draftRequest, {
					headers: {
						'Access-Control-Allow-Origin': 'https://greentravel.ua',
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
					.then((response) => {
						DD.log(response.data)
						if (response.data.uuid) {
							// если получили UUID
							this.draft = response.data
							DD.log(this.draft)

							if (this.draft.payment_url) {
								window.location.href = this.draft.payment_url
							} else {
								throw new Error('Payment url not found')
							}

							return true
						} else {
							throw new Error('Не удалось получить uuid')
						}
					})


					.catch((error) => {
						this.draft = false
						DD.error(error)

						this.log({
							method: 'checkoutDraft -- self',
							error: error,
							data: this.calcFields
						}, 'osago-error')

						if (error.response) {
							this.log({
								method: 'checkoutDraft -- fill_himself',
								error: error,
								data: this.calcFields
							}, CALC_TYPE + '-error')

							console.log(error.response)

							const errText = DEBUG ? JSON.stringify(error.response.data.message, null, '\t') : DEFAULT_ERR_TEXT

							Swal.fire({
								icon: 'error',
								title: 'Помилка',
								text: errText,
							})
						}
					})

					.finally(() => {
						checkoutBtn.classList.remove('_loading')
					})
			},



			setCity(cityID) {
				const citySelect = this.$refs.city
				DD.log('setCity = ' + cityID, this.$refs.city)
				citySelect.tomselect.setValue([cityID])
				citySelect.validation.errorMessage('hide')
			},


			setAddress() {
				this.fields.insurant.address = this.fields.insurant.city + ', ' + this.fields.insurant.street + ' ' + this.fields.insurant.house
				if (this.fields.insurant.flat != '') this.fields.insurant.address += ' / ' + this.fields.insurant.flat
			},


			async getINN() {
				let vue = this
				let inn = vue.fields.insurant.inn
				if (inn.toString().length > 10) {
					vue.fields.insurant.inn = vue.$refs.inn.value.slice(0, 10) // на всякий случай
					inn = vue.fields.insurant.inn
				}

				// DD.log('⭐ inn length:', inn, inn.toString().length, vue.$refs.inn.value.length)
				if (inn == '' || (inn.toString().length < 10)) return false

				try {
					let response = await axios.get(API + '/data/inn', {
						params: {
							search: inn
						}
					});

					if ((typeof response.data.success !== 'undefined' && response.data.success === false)
						|| (typeof response.data.status !== 'undefined' && response.data.status === false)) {
						throw new Error(response.data);
					}

					vue.fields.insurant.birth = response.data.birth
					vue.$refs.birthday.flatpickr().setDate(response.data.birth, true, 'Y-m-d')
					return true

				} catch (error) {
					DD.warn('ERR:', error.message)
					return false
				}
			},


			switchDiscountType() {
				this.fields.discount_check = (this.fields.discount_type > 0)
					? true : false
			},


			event_changeTransport_type() {
				// при изменении Transport_type сразу обновлять Transport_power
				let newPowerSelect = document.querySelector('#transport_power__' + this.fields.transport.transport_category_id)
				newPowerSelect.selectedIndex = 0
				this.fields.transport.transport_power_id = newPowerSelect.value

				const discountTypeEl = document.querySelector('.form_field.discount_type__wrap')
				if (this.fields.transport.transport_category_id == 2) {
					document.querySelector('#discount_type').tomselect.setValue(0)

					discountTypeEl.classList.add('_disabled')
					this.switchDiscountType()
				} else {
					discountTypeEl.classList.remove('_disabled')
				}
			},


			// Тут разные параметры для инициации TomSelect (на основе vue-директивы, например: v-smartselect='_init: "carModel"')
			getTomSelectInitParams(name) {
				const vue = this

				if (name == 'city') return {
					valueField: 'id',
					labelField: 'name',
					searchField: 'name',

					onChange: function (cityID) {
						let city
						if (cityID > 0 && typeof this.options !== 'undefined') {
							city = {
								id: cityID,
								name: this.options[cityID].name
							}

						} else {
							city = { id: null, name: null }
						}
						vue.fields.transport.city = city
						DD.log('CHANGE CITY', vue.$refs.city)
						vue.$refs.city.validation.validate()
					},

					load: function (query, callback) {
						let url = API + '/handbooks/cities/osago?search=' + encodeURIComponent(query);
						DD.log('url', url)
						axios.get(url)
							.then(function (response) {
								DD.log(response.data)
								callback(response.data)
							})
							.catch(function (err) {
								DD.log('city catch error', err)
								callback()
							})
					},

					render: {
						option: function (item, escape) {
							const optionName = item.region
								? item.name + ' (' + item.region.caption + ')'
								: item.name
							return `<div class="option"> ${escape(optionName)}</div>`;
						},
						item: function (item, escape) {
							const itemName = item.region
								? item.name + ' (' + item.region.caption + ')'
								: item.name
							return `<div class="item">${escape(itemName)}</div>`;
						}
					},
				}


				if (name == 'carModel') {
					return {
						// createOnBlur: true,
						// create: true,
						valueField: 'id',
						labelField: 'name',
						searchField: 'name',
						maxOptions: null,
						render: {
							option: function (item, escape) {
								return `<div class="option">${escape(item.name)}</div>`;
							},
							item: function (item, escape) {
								return `<div class="item">${escape(item.name)}</div>`;
							}
						},
					}
				}


				if (name == 'carMark') {
					return {
						// createOnBlur: true,
						// create: true,
						valueField: 'id',
						labelField: 'name',
						searchField: 'name',
						maxOptions: null,
						options: vue.handbooks.cars,
						render: {
							option: function (item, escape) {
								return `<div class="option">${escape(item.name)}</div>`;
							},
							item: function (item, escape) {
								return `<div class="item">${escape(item.name)}</div>`;
							}
						},
					}
				}

				return false
			},


			// Тут разные параметры для инициации календаря (на основе vue-директивы, например: v-calendar='init: "polisStart"')
			getCalendarInitParams(name) {
				if (name == 'polisStart') {
					return {
						minDate: polisStartDateByDefault
					}
				}


				if (name == 'insurantBirth') {
					return {
						minDate: (today.getFullYear() - 80) + '-' + (today.getMonth() + 1) + '-' + ((today.getDate()).toString().padStart(2, "0")),
						maxDate: (today.getFullYear() - 18) + '-' + (today.getMonth() + 1) + '-' + ((today.getDate()).toString().padStart(2, "0"))
					}
				}


				if (name == 'docDateStart') {
					return {
						minDate: (today.getFullYear() - 80) + '-' + (today.getMonth() + 1) + '-' + ((today.getDate()).toString().padStart(2, "0")),
						maxDate: (today.getFullYear()) + '-' + (today.getMonth() + 1) + '-' + ((today.getDate()).toString().padStart(2, "0"))
					}
				}

				return false
			},


			findCarInfoByGovNum() {
				if (this.fields.transport.gov_num.length == 8) {

					const inputs__gov_num = document.querySelectorAll('.input__gov_num')
					inputs__gov_num.forEach(item => item.classList.add('_loading'))

					axios.get(API + '/handbooks/cars/findBot', {
						timeout: 10000,
						params: {
							search: this.fields.transport.gov_num,
						}
					})

						.then((response) => {
							const resp = Array.isArray(response.data) ? response.data[0] : response.data
							DD.log('findCarInfoByGovNum:', resp)
							if (typeof resp == 'undefined' || ('status' in resp && resp.status == 'error')) throw new Error('Error findCarInfoByGovNum(): empty response')

							// const carMarkSelect  = this.$refs.car_mark.tomselect
							// const carModelSelect = this.$refs.car_model.tomselect

							this.status.isCarFoundByGovNum = 2 // нашло

							this.fields.transport.car_mark = {}
							this.fields.transport.car_model = {}

							this.fields.transport.vin = resp.vin
							this.fields.transport.car_year = resp.makeYear
							this.fields.transport.car_mark.name = resp.brand
							this.fields.transport.car_mark.id = resp.car_mark_id
							this.fields.transport.car_model.name = resp.model
							this.fields.transport.car_model.id = resp.car_model_id

							this.fields.transport.transport_category_id = resp.transport_category_id
							this.fields.transport.transport_power_id = resp.transport_power_id

							this.loadAndSetCarModelsByCarID(resp.car_mark_id, resp.car_model_id)

							// фикс бага с номером BA4187BC
							if (resp.transport_power_id == '' || resp.transport_power_id == null || resp.transport_category_id == '' || resp.transport_category_id == null) {
								this.status.isCarFoundByGovNum = 0 // нашло не всё
								this.fields.transport.transport_category_id = 1
								this.fields.transport.transport_power_id = 1
								this.gotoStep(1)
							}

							// если всё на нулевом шаге - делаем пометку и переходим на шаг 1
							else if (this.status.steps.current == 0) {
								this.status.isCarFoundByGovNum = 1 // нашло на 1 шаге
								this.gotoStep(1)
							}
							DD.log('isCarFoundByGovNum: ', this.status.isCarFoundByGovNum)
						})


						.catch((error) => {
							// Swal.fire({
							// 	icon: 'warning',
							// 	// title: 'Помилка',
							// 	text: 'Нажаль не вдалося знайти авто за номером, скористуйтесь розрахунком за параметрами ТЗ',
							// })
							DD.warn(error)
							if (this.status.steps.current == 0) {
								this.status.isCarFoundByGovNum = 0
								this.gotoStep(1)
							}
						})

						.finally(() => {
							inputs__gov_num.forEach(item => item.classList.remove('_loading'))
						})
				}
			},



			loadAndSetCarModelsByCarID(car_id, set_model_id = null) {
				const carMarkSelect = this.$refs.car_mark.tomselect
				const carModelSelect = this.$refs.car_model.tomselect
				DD.log('loadAndSetCarModelsByCarID', car_id, set_model_id)

				// если новое значение не равно текущему, то меняем его и очищаем модель
				if (carMarkSelect.getValue() != car_id) carMarkSelect.setValue(car_id)

				carModelSelect.clear()
				carModelSelect.clearOptions()
				this.fields.transport.car_model = {}

				axios.get(API + '/handbooks/cars/' + car_id + '/models')
					.then((response) => {
						// carModelSelect.clear()
						// carModelSelect.clearOptions()
						// carModelSelect.addOptions(response.data)
						// this.fields.transport.car_model = {}
						carModelSelect.addOptions(response.data)
						this.handbooks.models = response.data
						DD.log('loadAndSetCarModelsByCarID LOADED!', response.data)
					})
					.then(() => {
						if (set_model_id) {
							DD.log('loadAndSetCarModelsByCarID SETVALUE:', set_model_id)
							carModelSelect.setValue(set_model_id)
						}
					})
			},




			changeCarMark() {
				const carMarkSelect = this.$refs.car_mark.tomselect
				const carMark = _.find(carMarkSelect.options, (option) => { return option.id == carMarkSelect.getValue() })


				this.fields.transport.car_mark = {
					name: carMark.name,
					code: carMark.external_id,
					id: carMark.id,
				}

				DD.log('changeCarMark:', carMark)
				this.loadAndSetCarModelsByCarID(carMark.id)
			},



			changeCarModel() {
				// const carModelSelect = document.querySelector('#formfield_car_model').tomselect
				const carModelSelect = this.$refs.car_model.tomselect
				DD.log('carModelSelect:', carModelSelect.options)
				const carModel = _.find(carModelSelect.options, (option) => { return option.id == carModelSelect.getValue() })
				DD.log('changeCarModel:', carModel)
				// const carModel = carModelSelect.options[carModelSelect.getValue()]

				if (typeof carModel != 'undefined') {
					this.fields.transport.car_model = {
						name: carModel.name,
						code: carModel.external_id,
						id: carModel.id,
					}
				}

			},



			log($data, $filename = CALC_TYPE + '-error') {
				if ($data !== null && $data.constructor.name === " Object")
					$data = JSON.stringify($data)

				DD.log("LOG DATA:\n", $data, "LOG FILENAME:\n", $filename)
				axios.post(CALC_URL + '/' + CALC_TYPE + '/log.php', {
					"data": $data,
					"filename": $filename
				}, {
					headers: {
						'Access-Control-Allow-Origin': 'https://' + window.location.host,
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
					.then((response) => {
						DD.log("SAVE LOG\n", response)
					})
			},


			getCashback() {
				let cashback = {
					phone: '',
					bankcard: '',
					zsu: false,
				}
				switch (this.fields.cashback.selected) {
					case 'phone':
						cashback.phone = '+380' + this.fields.cashback.phone; break;

					case 'bankcard':
						cashback.bankcard = this.fields.cashback.bankcard; break;

					case 'zsu':
						cashback.zsu = true;
				}
				return cashback
			},


			checkAndChangeCashbackPhone() {
				const el_phone = this.$refs.insurant_phone
				const el_cashbackPhone = this.$refs.cashback_phone
				const phone = getPhoneNumbers(el_phone)

				if (typeof el_cashbackPhone == 'undefined' || this.fields.cashback.is_phone_changed == true) return false

				// $this.fields.insurantPhone = phone.full
				// el_phone.value = phone.short

				DD.log('is_phone_changed: ', phone, this.fields.cashback.is_phone_changed)

				if (phone.countryCode == '+380' && (phone.short.trim()).charAt(0) != '+' && phone.short.length == 9) {
					DD.log('set el_cashbackPhone')
					this.fields.cashback.phone = phone.short
					// el_cashbackPhone.value = phone.short
					el_cashbackPhone.intlTelInputInstance.setNumber(phone.full)
				}
			},



			isElementVisible(el) {
				const rect = el.getBoundingClientRect()
				const style = window.getComputedStyle(el)

				return (
					el.offsetWidth > 0 && el.offsetHeight > 0 &&
					style.display !== 'none' &&
					style.visibility !== 'hidden' &&
					style.opacity !== '0' &&
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				)
			},


			checkIsTest() {
				const $_GET = new URLSearchParams(window.location.search);
				if ($_GET.get('test') != null) {
					setTimeout(() => {
						axios.get(CALC_URL + '/' + CALC_TYPE + '/test.php?test=' + $_GET.get('test'))

							.then((response) => {
								let testData = response.data
								DD.log("GET test\n", CALC_URL + 'test.php?test=' + $_GET.get('test'), testData)
								if (testData.result === false) throw new Error('Error checkIsTest()')
								Object.assign(this, testData)
								this.getPrice()
							})

							.catch((error) => {
								DD.log("ERROR get test\n", error)
								this.log({
									method: 'checkIsTest',
									error: error,
									error_response: error.response,
									data: response.data
								}, CALC_TYPE + '-error')
								DD.log("ошибка в тесте\n", error)
							})
					}, 500)
				}
			},
		},


		watch: {
			// === Группа зависимостей для getPrice ===
			'fields.scoringBirthYear'(val) {
				if (this.fields.insurant.birth == null) {
					const birthday = this.fields.scoringBirthYear + '-06-01'
					window.insurantBirth.setDate(birthday, true, 'Y-m-d')
					// this.fields.insurant.birth.setDate(birthday, true, 'Y-m-d')
				}

				if (this.fields.use_scoring == 1) this.getPrice()
			},

			'fields.insurant.birth'(val) {
				if (this.fields.use_scoring == 1) this.getPrice()
			},

			'fields.transport.car_year'(val) {
				if (this.fields.use_scoring == 1) this.getPrice()
				document.querySelector('#formfield_car_year').tomselect.setValue(this.fields.transport.car_year)
				// document.querySelector('#scoringCarYearSelect').tomselect.setValue(this.fields.transport.car_year)
			},

			'fields.discount_check'() { this.getPrice() },
			'fields.transport.city.id'() { this.getPrice() },
			'fields.trip_duration'() { this.getPrice() },
			'fields.franchise'() { this.getPrice() },
			'fields.dgo_limit'() { this.getPrice() },
			'fields.use_as_taxi'() { this.getPrice() },
			'fields.discount_check'() { this.getPrice() },
			'fields.promocode'() { this.getPrice() },
			'fields.transport.transport_power_id'() { this.getPrice() },
			'fields.insurant.type'() { this.getPrice() },

			// ================================

			/* Смена типа документа */
			'fields.insurant.doc_type'(val) {
				if (val == 2) { // ID-карта
					this.status.user_data.insurant.doc_series = this.fields.insurant.doc_series // запомнили введённое
					this.fields.insurant.doc_series = 'ID'

				} else if (val == 1) { // паспорт
					this.fields.insurant.doc_series = this.status.user_data.insurant.doc_series
				}
			},

			// если заполнили инфу по скорингу - можно кликать
			'fields.use_scoring'() {
				if (this.fields.use_scoring == -1
					&& this.fields.scoringBirthYear > 0
					&& this.fields.car.year > 0) {
					this.fields.use_scoring = 0
				}
			}
		},


		mounted() {
			document.querySelector('.calc__wrap').classList.add("loaded")

			this.checkIsTest()

			// Для брошенной корзины
			document.querySelectorAll('#calc input, #calc select, #calc textarea').forEach((element) => {
				element.addEventListener('change', () => {
					this.saveDraft()
				})
			})
		},
	})








	APP.directive('validate', {
		mounted(el, binding, vnode) {
			const error_class = 'is-invalid'

			el.validation = {
				el: el,
				model: binding.value.model, // привязка к vue значениям реактивности
				rules: binding.value.rules, // набор правил валидации. Имя => сообщение об ошибке

				isVisible: () => binding.instance.isElementVisible(el), // проверка видимости

				errorMessage: function (action, message = '') {
					// сначала удаляем предыдущий статус
					el.classList.remove(error_class)
					let nextSibling = el.nextElementSibling;
					if (nextSibling && nextSibling.classList.contains('invalid-feedback')) {
						nextSibling.remove()
					}

					// если надо - выводим новое
					if (action == 'show') {
						el.classList.add(error_class)

						if (message != '') {
							let errorMessage = document.createElement('div')
							errorMessage.className = 'invalid-feedback'
							errorMessage.textContent = message
							el.insertAdjacentElement('afterend', errorMessage)
						}

					}
				},

				validate: async function () {
					const value = el.value;
					let error = false;

					// правила обработки валидации
					if (Object.keys(el.validation.rules).length) {
						// Используем for...of для корректной работы с async/await
						for (let [rule, error_msg] of Object.entries(el.validation.rules)) {
							switch (rule) {
								case 'required':
									if (value == '') error = error_msg;
									break;

								case 'email':
									if (!/\S+@\S+\.\S+/.test(value)) error = error_msg;
									break;

								case 'inn':
									const checkINN = await binding.instance.getINN();
									if (checkINN === false) error = error_msg;
									break;

								case 'model_value_required':
									if (_.get(binding.instance, el.validation.model) == ''
										|| _.get(binding.instance, el.validation.model) == null
										|| typeof (_.get(binding.instance, el.validation.model)) == 'undefined') {
										error = error_msg;
									}
									break;
							}

							// Прерывание цикла при первом ошибочном правиле
							if (error) break;
						}
					}

					if (error) {
						// DD.warn('NOT VALID ' + el.validation.model, error, el.validation, el)
						el.validation.errorMessage('show', error);
					} else {
						// DD.log('VALID ' + el.validation.model)
						el.validation.errorMessage('hide')
					}

					return error ? false : true;
				}
			}

			// собираем все поля для последующих проверок
			binding.instance.status.validation.elements[el.validation.model] = el.validation

			el.addEventListener('blur', () => el.validation.validate())
		}
	})





	APP.directive('popover', {
		mounted(el, binding) {
			// $(el).popover()
			let popId = el.dataset.popoverId
			popovers[popId] = new bootstrap.Popover(el, {
				container: '#calc'
			})
		}
	})



	APP.directive('calendar', {
		mounted(el, binding) {
			const flatpickrArgsDefault = {
				disableMobile: "true",
				altInput: true,
				allowInput: true,
				altFormat: "d.m.Y",
				dateFormat: "Y-m-d",
				"locale": "uk"
			}

			let flatpickrArgs = typeof binding.value !== 'undefined'
				? binding.instance.getCalendarInitParams(binding.value._init) // APP
				: {}

			flatpickrArgs = _.merge(flatpickrArgsDefault, flatpickrArgs)

			window[el.id] = flatpickr(el, flatpickrArgs);
			if (el.id == 'polisStart') {
				window.polisStart.setDate(defaultOrderPolisStart, true, 'Y-m-d')
			}
		}
	})



	APP.directive('smartselect', {
		mounted(el, binding) {
			let selectArgsDefault = {
				maxOptions: 100,
				// controlInput: false,
				// onDelete: function(values) {
				// 	return false // чтобы запретить удаление элементов на Backspace
				// },
				render: {
					option_create: function (data, escape) {
						return '<div class="create">Вибрати <strong>' + escape(data.input) + '</strong>&hellip;</div>';
					},
					no_results: function (data, escape) {
						return '<div class="no-results">Не знайдено</div>';
					}
				}
			}

			if (typeof binding.value._options !== 'undefined')
				selectArgsDefault = _.merge(selectArgsDefault, binding.value._options)

			let selectArgs = typeof binding.value !== 'undefined'
				? binding.instance.getTomSelectInitParams(binding.value._init)
				: {}

			selectArgs = _.merge(selectArgsDefault, selectArgs)

			new TomSelect(el, selectArgs)
		}
	})



	APP.directive('phonemask', {
		mounted(el, binding) {
			const defaults = {
				initialCountry: "ua",
				// separateDialCode: true,
				showSelectedDialCode: true,
				// autoHideDialCode: false,
				countrySearch: false,
				utilsScript: CALC_URL + "/assets/js/utils.js"
			}

			let initArgs = typeof binding.value.config !== 'undefined'
				? binding.value.config : {}

			const args = _.merge(defaults, initArgs)
			// DD.log('phonemask:', el, binding, args)
			// window[el.id] = intlTelInput(el, args)
			el.intlTelInputInstance = intlTelInput(el, args)

			// let el_phone = document.getElementById('phone')
			// const el_phone = this.$refs.insurant_phone

			if (typeof binding.value.ref !== 'undefined' && binding.value.ref == 'insurant_phone') {
				const el_phone = binding.instance.$refs[binding.value.ref]

				"change countrychange keyup".split(" ").forEach(function (e) {
					el_phone.addEventListener(e, function () {
						const phone = getPhoneNumbers(el)
						binding.instance.fields.insurant.phone = phone.full
						// el_phone.value = phone.short
						if (binding.instance.status.price.cashback > 0) {
							binding.instance.checkAndChangeCashbackPhone()
						}
					}, false)
				})
			}
		}
	})



	APP.directive('inputmaskbankcard', {
		mounted(el, binding) {
			new Inputmask({ "mask": "9999-9999-9999-9999" }).mask(el)
		}
	})



	function getPhoneNumbers(el) {
		const $return = {}

		$return.full = el.intlTelInputInstance.getNumber(intlTelInputUtils.numberFormat.E164)
		$return.countryCode = '+' + el.intlTelInputInstance.getSelectedCountryData().dialCode
		$return.short = $return.full.replace($return.countryCode, '')

		return $return
	}






	APP.mount('#calc')
})
